import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { PointCardEditCompleteTemplate } from 'components/Templates'

const PointCardEditComplete: FC = () => {
  return (
    <Layout title={'ポイントカード'}>
      <PointCardEditCompleteTemplate />
    </Layout>
  )
}

export default PointCardEditComplete
